import type { PopupData } from 'webapp-types';

import type { Args as PopupInnerBaseArgs } from 'webapp/components/popup/inner/base';
import PopupInnerBase from 'webapp/components/popup/inner/base';

import type PopupContext from 'webapp/models-custom/popup/context';

export interface Args extends PopupInnerBaseArgs {
	model: PopupContext;
}

export default abstract class PopupInnerContextComponent<
	TData extends object = PopupData.Any,
> extends PopupInnerBase<Args> {
	declare __popupData: TData; // just for type inference - see types/webapp/common:InferPopupData

	get popupData(): TData {
		return this.args.model.data as TData;
	}
}
